// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"56978630","372":"4af6ad1b","500":"536061f3","592":"2fc66b92"}[chunkId] + ".chunk.js";
};